import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";
import { EVENT_USER_SURVEY } from "@/feature-survey/constants.mjs";

export function onSurveyPostmatch(payload) {
  return refs.trackEvent(EVENT_USER_SURVEY, payload);
}
